import React from 'react'
import { Button } from '@mui/material'
import AppDialog from '../../../components/dialog/AppDialog'

export default function PriceDetailsDialog({ row, onClose }) {
    return (
        <AppDialog open={Boolean(row)} onClose={onClose} title='Pricing details' actions={<Button onClick={onClose}>Close</Button>}>
            <pre className='sap-direct-price-json'>{JSON.stringify(row?.response || {}, null, 2)}</pre>
        </AppDialog>
    )
}
